import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Constants from 'root/constants';
import Router from 'root/router';
import Modals from 'root/modals';
import View from 'view/base';
import PDFJS from 'root/module/pdfjs';
import { toggleWatch } from 'service/feedback';
import Template_Action_Dropdown from 'template/feedback/action_dropdown';

export default View.extend({
    className: 'feedback-preview',

    show_screenshot: null, // force to show screenshot regardless of user setting

    events: {
        'click .side-info a'      : 'preventClick',
        'click .id'               : 'preventClick',
        'click'                   : 'open',
        'click .view'             : 'openGrid',
        'click .feedback-delete'  : 'onDelete',
        'click .feedback-share'   : 'onShare',
        'click .feedback-rename'  : 'onRename',
        'click .feedback-publish' : 'onApproveIdea',
        'click .feedback-move'    : 'onMove',
        'click .feedback-merge'   : 'onMergeFeedback',
        'click .feedback-unmerge' : 'onUnmergeFeedback',
        'click .feedback-watch'   : 'onWatch',
        'click li.user-assign'    : 'onSetUser',
        'click .user-invite'      : 'onInviteUser',
        'click .id input'         : 'onSelect',
        'mouseleave'              : 'onMouseLeave'
    },

    dom_handlers: {
        onSelect: function(e) {
            if ($(e.currentTarget).prop('checked')) {
                this.$el.addClass('feedback-preview-selected');
                this.model.set('selected', true);
            } else {
                this.$el.removeClass('feedback-preview-selected');
                this.model.set('selected', false);
            }
        },

        preventClick: function(e) {
            e.stopPropagation();
        },

        open: function(e) {
            if (this.example_mode) {
                return;
            }

            if ($(e.target).parents('.button-dropdown-actions').length) {
                return;
            }

            if ($(e.target).parents('.button-dropdown-user-assign').length) {
                return;
            }

            var highlight = false;

            switch (this.view_type()) {
                case 'grid':
                    if (UI.isMobile()) {
                        return;
                    }

                    this.$el.find('.id input').click();

                    break;
                case 'list':
                    // feedback-preview-container has-selection
                    if ($('.feedback-preview-container').hasClass('has-selection')) {
                        this.$el.find('.id input').click();
                    } else {
                        highlight = true;
                        Modals.openFeedbackSidebar(this.model.id);
                    }

                    break;
                case 'column':
                    highlight = true;
                    Modals.openFeedbackSidebar(this.model.id);
                    break;
                case 'inbox':
                    if (UI.isMobile()) {
                        Modals.openFeedbackSidebar(this.model.id);
                    } else {
                        highlight = true;

                        this.trigger('open:inbox', this.model);

                        Router.addQueryString('feedback_id', this.model.id, {trigger: false});
                    }

                    break;
            }

            if (highlight) {
                $('.feedback-preview').removeClass('feedback-preview-open');
                this.$el.addClass('feedback-preview-open');
            }
        },

        openGrid: function(e) {
            e.stopPropagation();

            if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
                Modals.openFeedback(this.model.id);
            } else {
                Modals.openFeedbackSidebar(this.model.id);
            }
        },

        onDelete: function(e) {
            e.stopPropagation();
            Modals.deleteFeedback([this.model.id]);
        },

        onShare: function(e) {
            e.stopPropagation();
            Modals.shareFeedback(this.model);
        },

        onRename: function(e) {
            e.stopPropagation();

            if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
                Modals.renameDesign(this.model.id);
            } else {
                Modals.renameFeedback(this.model.id);
            }
        },

        onApproveIdea: function(e) {
            e.stopPropagation();

            if (this.model.isMergedFeedback()) {
                return;
            }

            if (this.model.get('is_portal_approved')) {
                Modals.unapproveFeatureRequest(this.model);
            } else {
                Modals.approveFeatureRequest(this.model);
            }
        },

        onMove: function(e) {
            e.stopPropagation();
            Modals.moveFeedback([this.model.id]);
        },

        onSetUser: function(e) {
            if (this.example_mode) {
                return;
            }

            var user_id = parseInt($(e.currentTarget).data('id'));

            if (isNaN(user_id)) {
                return;
            }

            if (user_id === this.model.get('user_id')) {
                return;
            }

            Cache.app.request({
                action: 'feedback/setUser',
                context: this,
                data: {
                    ids     : [this.model.id],
                    user_id : user_id
                }
            });

            this.model.set({user_id: user_id});

            if (user_id) {
                UI.success('Feedback assigned');
            } else {
                UI.success('Feedback unassigned');
            }
        },

        onInviteUser: function(e) {
            Modals.inviteUser();
        },

        onMergeFeedback: function(e) {
            e.preventDefault();
            Modals.mergeFeedback(this.model.id);
        },

        onUnmergeFeedback: function(e) {
            e.preventDefault();

            Modals.unmergeFeedback(this.model.id);
        },

        onMouseLeave: function () {
            if (this.view_type() === 'list') {
                return;
            }

            this.$el.find('.button-dropdown-actions > div').hide();
        },

        onWatch: function(e) {
            toggleWatch(this.model.id);
        }
    },

    event_handlers: {
        onApproverChange: function(model) {
            if (model.get('feedback_id') === this.model.id) {
                this.render();
            }
        },

        onApprove: function(model) {
            if (model.get('feedback_id') === this.model.id) {
                this.render();
            }
        },

        onFeedbackOpen: function(feedback_id) {
            if (feedback_id !== this.model.id) {
                return;
            }

            Modals.openFeedback(this.model.id);
        }
    },

    initialize: function(options) {
        this.view_type       = options.view_type;
        this.groupby         = options.groupby;

        this.example_mode    = !!options.example_mode;
        this.show_screenshot = options.show_screenshot;

        this.listenTo(this.model,     'change:sentiment',           this.render);
        this.listenTo(this.model,     'change:action_required',     this.render);
        this.listenTo(this.model,     'change:update',              this.render);
        this.listenTo(this.model,     'change:category',            this.render);
        this.listenTo(this.model,     'change:priority',            this.render);
        this.listenTo(this.model,     'change:user_id',             this.render);
        this.listenTo(this.model,     'change:page',                this.render);
        this.listenTo(this.model,     'change:title',               this.render);
        this.listenTo(this.model,     'change:is_portal_approved',  this.render);
        this.listenTo(this.model,     'change:primary_feedback_id', this.render);
        this.listenTo(this.model,     'change:merged_feedback_ids', this.render);
        this.listenTo(this.model,     'change:due_date',            this.render);
        this.listenTo(this.model,     'change:workflow',            this.render);
        this.listenTo(Cache.workflow, 'add remove',                 this.render);
        this.listenTo(Cache.feedback_watch_list, 'add',             this.render);
        this.listenTo(Cache.feedback_watch_list, 'remove',          this.render);
        this.listenTo(Cache.feedback_watch_list, 'reset',           this.render);

        Cache.app.dispatcher.on('feedback:toggle:screenshot', this.render.bind(this));

        if (Cache.portal.findWhere({project_id: Cache.default_project_id})) {
            this.listenTo(this.model, 'change:feedback_type', this.render);
        }

        if (this.model.isDesign()) {
            this.listenTo(Cache.feedback_approver, 'add',    this.event_handlers.onApproverChange);
            this.listenTo(Cache.feedback_approver, 'remove', this.event_handlers.onApproverChange);

            this.listenTo(Cache.feedback_screenshot, 'change:is_approved', this.event_handlers.onApprove);
        }

        Cache.app.dispatcher.on('Feedback:Open', this.event_handlers.onFeedbackOpen.bind(this));

        if (this.model.get('load_type') === 'upload' && !Cache.account.hasFeature('image_feedback')) {
            this.is_locked = true;
        } else {
            this.is_locked = false;
        }

        if (this.model.isPdf()) {
            this.is_pdf_rendered = false;
        }
        this.is_playing = false;
    },

    isDesignApproved: function() {
        return Cache.feedback_screenshot.where({feedback_id: this.model.id, is_approved: true}).length > 0;
    },

    isPendingDesignApproval: function() {
        return Cache.feedback_approver.where({feedback_id: this.model.id}).length > 0 && !this.isDesignApproved();
    },

    getApprovedBy: function() {
        var approved_screenshot = Cache.feedback_screenshot.findWhere({feedback_id: this.model.id, is_approved: true});

        if (approved_screenshot) {
            var user_id = approved_screenshot.get('approved_by');
            var user    = Cache.user.get(user_id);

            if (user) {
                return user.get('name');
            } else {
                return 'Deleted user';
            }
        }

        return '';
    },

    getApprover: function() {
        var approver = Cache.feedback_approver.findWhere({feedback_id: this.model.id});

        if (approver) {
            var user_id = approver.get('user_id');
            var user    = Cache.user.get(user_id);

            if (user) {
                return user.get('name');
            } else {
                return 'Deleted user';
            }
        }

        return '';
    },

    pulse: function() {
        this.$el.addClass('pulsing');
    },

    render: function() {
        var view_type = this.view_type();

        this.$el.attr('viewtype', view_type);

        this.$el.removeClass('feedback-preview-selected');

        var is_design = this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload();
        var show_screenshot = false;

        if (typeof this.show_screenshot === 'boolean') {
            show_screenshot = this.show_screenshot;
        } else {
            show_screenshot  = Cache.app.getUserSetting('show_screenshot', true) === null ? true : Cache.app.getUserSetting('show_screenshot', true);
        }

        var content = '';

        // Category badge
        var categories = '';
        if (this.model.get('category')) {
            _.each(this.model.get('category').split(','), function(category) {
                categories += '<span>#' + Util.htmlEntities(category) + '</span>';
            });
        }

        // User dorpdown
        var users = Cache.app.getUsersByProject(Cache.default_project_id, [Constants.ADMIN, Constants.ASSIGNEE]);
        var user_assigned = Cache.user.get(this.model.get('user_id'));
        var user_options = '<li data-id="0" class="user-assign' + (this.model.get('user_id') === 0 ? ' selected' : '') + '">' +
                                '<img class="user-img" src="/image/profile.png">Unassigned' +
                            '</li>';
        users.forEach((user) => {
            user_options += '<li data-id="' + user.id + '" class="user-assign' + (user.id === this.model.get('user_id') ? ' selected' : '') + '">' +
                                '<img class="user-img" src="' + user.getAvatar(24) + '">' + user.escape('name') +
                            '</li>';
        });

        var feedback_screenshot          = Cache.feedback_screenshot.where({feedback_id: this.model.id});
        var feedback_screenshot_approved = Cache.feedback_screenshot.findWhere({feedback_id: this.model.id, is_approved: true});
        var screenshot_url    = '';
        var screenshot_width  = 0;
        var screenshot_height = 0;

        if (feedback_screenshot_approved) {
            screenshot_url    = feedback_screenshot_approved.get('url');
            screenshot_width  = feedback_screenshot_approved.get('window_x');
            screenshot_height = feedback_screenshot_approved.get('window_y');
        } else if (feedback_screenshot.length) {
            screenshot_url    = feedback_screenshot[0].get('url');
            screenshot_width  = feedback_screenshot[0].get('window_x');
            screenshot_height = feedback_screenshot[0].get('window_y');
        } else if (this.model.get('screenshot')) {
            screenshot_url = this.model.get('screenshot');
        }

        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

        var is_merged_feedback = this.model.isMergedFeedback();
        var is_priamry_feedback = this.model.isPrimaryFeedback();

        var is_following = Cache.feedback_watch_list.findWhere({feedback_id: this.model.id, user_id: Cache.real_user_id}) ? true : false;

        if (this.model.isExpired()) {
            content += '<div class="feedback-time-expired tooltip" data-title="Feedback Availability Reached">Expired</div>';
        }

        content += '<div class="preview">';

        if (!Cache.app.isClient()) {
            content += '<div class="id">' +
                            '<input type="checkbox" id="feedback_preview_selection_' + this.model.id + '"' + (this.model.get('selected') === true ? ' checked' : '') + (this.model.get('primary_feedback_id') ? ' disabled': '') + '>' +
                            '<label for="feedback_preview_selection_' + this.model.id + '"></label>' +
                        '</div>';
        }

        var subject = '';
        var page_title = '';
        if (this.model.isDesign() && this.model.isPdf()) {
            subject = this.model.get('page');
        } else if (this.model.get('title')) {
            subject = this.model.get('title');
        } else if (this.model.get('description')) {
            subject = this.model.get('description');
        } else {
            subject = this.model.escape('page');
            page_title = this.model.get('page_title');
        }

        var subject_char_limit = view_type === 'list' ? 200 : 100;

        if (view_type === 'grid') {
            if (this.model.get('video_url')) {
                content += '<div class="video-bg">' +
                                '<video preload="metadata" src="' + this.model.escape('video_url') + '" muted></video>' +
                            '</div>';
            } else if (this.model.isPdf()) {
                content += '<div class="pdf-bg"><canvas></canvas></div>';
            } else {
                var bg_class = 'screenshot-bg';

                if (!screenshot_url) {
                    bg_class = 'screenshot-bg screenshot-empty';
                } else if (screenshot_width > 0 && screenshot_width < 310 && screenshot_height < 180) {
                    // small design file or small screenshot (selected area)
                    bg_class = 'screenshot-bg screenshot-bg-auto';
                }

                content += '<div class="' + bg_class + '"' + (screenshot_url ? 'style="background-image:url(\'' + Util.htmlEntities(screenshot_url) + '\');"' : '') + '>' + (screenshot_url ? '' : 'No screenshot provided') + '</div>';
            }
        }

        if (view_type === 'inbox' || view_type === 'column') {
            if (!this.model.isExpired()) {
                content += '<div class="feedback-time">' + Util.moment(this.model.get('time'), 'MMM DD') + '</div>';
            }
        }

        var is_overdue = this.model.isOverdue();
        var is_due_today = this.model.isDueToday();
        var due_date_timestamp = this.model.get('due_date');
        var formated_due_date = due_date_timestamp ? Util.moment(due_date_timestamp, 'MMM D', false, false) : '';

        content +=     '<div class="description">' +
                            (view_type === 'grid' ? '' :
                            '<div class="flex-start">' +
                                '<div class="feedback-id badge-id">' + this.model.id + '</div>' +
                                '<div class="feedback-type">' + this.model.getFeedbackTypeName(false) + '</div>' +
                                (this.model.get('sentiment') ?
                                '<div class="feedback-sentiment tooltip" data-title="User sentiment: ' + this.model.getSentimentText() + '">' + this.model.getSentimentIcon() + '</div>' : '') +
                                (is_following ?
                                '<div class="following-icon"><i class="fa-solid fa-bookmark text-icon tooltip" data-title="Following"></i></div>' : '') +
                            '</div>' +

                            (view_type === 'inbox' ?
                            '<div class="feedback-name">' + Util.htmlEntities(this.model.getReporterName()) + '</div>' : '' ) +

                            '<div class="subject">' + Util.htmlEntities(Util.trim(subject, subject_char_limit)) + '</div>') +

                            (view_type === 'list' && page_title ?
                            '<div class="page-title">' + page_title + '</div>' : '') +

                            (view_type !== 'grid' && categories && !is_merged_feedback ?
                            '<div class="category">' + categories + '</div>' : '');

        if (view_type === 'column' && show_screenshot) {
            if (this.model.get('video_url')) {
                content += '<div class="video-bg">' +
                                '<video preload="metadata" src="' + this.model.escape('video_url') + '" muted></video>' +
                            '</div>';
            } else if (screenshot_url) {
                content += '<div class="screenshot-bg"' + (screenshot_url ? 'style="background-image:url(\'' + Util.htmlEntities(screenshot_url) + '\');"' : '') + '></div>';
            }
        }

        content +=          '<div class="stats">' +
                                '<div class="count">' +
                                    (this.model.get('priority') !== 'neutral' && (view_type === 'column' || view_type === 'grid') ?
                                    '<span class="feedback-info-priority tooltip priority-text-' + (this.model.escape('priority').toLowerCase()) + '" data-title="' + Util.cap(this.model.escape('priority')) + '"><i class="fas fa-flag"></i></span>' : '') +

                                    (view_type === 'grid' || view_type === 'list' ?
                                    '<span class="feedback-info-time tooltip" data-title="Created: ' + Util.moment(this.model.get('time'), 'MMM D YYYY, hh:mm', false, false) + '">' + Util.moment(this.model.get('time'), 'MMM D', false, false) + '</span>' : '') +

                                    (is_overdue ?
                                    '<span class="overdue tooltip text-danger" data-title="Overdue"><i class="text-danger fa-regular fa-calendar-circle-exclamation"></i> ' + formated_due_date + '</span>' : '') +

                                    (is_due_today ?
                                    '<span class="overdue tooltip text-warning" data-title="Due Today"><i class="text-warning fa-regular fa-calendar-circle-exclamation"></i> ' + formated_due_date + '</span>' : '') +

                                    (!is_overdue && !is_due_today && due_date_timestamp ?
                                    '<span class="due-date tooltip" data-title="Due date"><i class="fa-regular fa-calendar-clock"></i> ' + formated_due_date + '</span>' : '') +

                                    '<span class="feedback-info-comments tooltip" data-title="' + (this.model.get('action_required') === Constants.ACTION_REQUIRED_PENDING ? 'Awaiting response' : this.model.getTotalComments() + ' comments') + '"><i class="fa-solid ' + (this.model.get('action_required') === Constants.ACTION_REQUIRED_PENDING ? 'fa-reply-clock' : 'fa-comment-lines') + '"></i> ' + this.model.getTotalComments() + '</span>' +

                                    (this.model.getVoteCount() && view_type !== 'grid' ?
                                    '<span class="feedback-info-vote tooltip" data-title="' + this.model.getVoteCount() + ' vote' + (this.model.getVoteCount() === 1 ? '' : 's') + '"><i class="fa-solid fa-circle-arrow-up"></i> ' + this.model.getVoteCount() + '</span>' : '') +

                                    (is_priamry_feedback ?
                                    '<span class="feedback-info-merged-count tooltip" data-title="' + this.model.getMergedFeedbackCount() + ' merged feedback' + (this.model.getMergedFeedbackCount() === 1 ? '' : 's') + '"><i class="fa-solid fa-diagram-cells"></i> ' + this.model.getMergedFeedbackCount() + '</span>' : '') +
                                '</div>' +

                                (is_design ? '' :
                                '<div class="extra">' +
                                    (is_merged_feedback ?
                                    '<div><i class="fa-solid fa-merge tooltip" data-title="Merged"></i></div>' :

                                    (this.model.get('attachment') ?
                                    '<div><i class="fa-solid fa-paperclip tooltip" data-title="Attachment"></i></div>' : '') +

                                    (this.model.get('screenshot') ?
                                    '<div><i class="fa-solid fa-draw-square tooltip" data-title="Screenshot"></i></div>' : '') +

                                    (this.model.get('video_url') ?
                                    '<div><i class="fa-solid fa-video tooltip" data-title="Screen Recording"></i></div>' : '') +

                                    (this.model.get('session_recording_id') ?
                                    '<div><i class="fa-solid fa-play-circle tooltip" data-title="Session Replay"></i></div>' : '')) +

                                    (this.model.get('is_portal_approved') && this.model.get('feedback_type') === Constants.FEEDBACK_FEATURE_REQUEST ?
                                    '<div><i class="fa-solid fa-eye tooltip" data-title="Visible in ideas portal"></i></div>' : '') +

                                    ((view_type === 'column' || view_type === 'list') && this.groupby !== 'assignee' && !Cache.app.isClient() ?
                                    '<div class="button-dropdown button-dropdown-large button-dropdown-user-assign">' +
                                        '<button type="button" class="tooltip' + (user_assigned ? '' : ' user-assign-empty') + '" data-title="' + (user_assigned ? 'Assigned to: ' + user_assigned.escape('name') : 'Unassigned') + '">' +
                                        (user_assigned ? '<img src="' + user_assigned.getAvatar() + '">' : '<i class="far fa-user"></i>') +
                                        '</button>' +
                                        '<div>' +
                                            (users.length > 10 ?
                                            '<div class="dropdown-search">' +
                                                '<input type="text" class="solid compact" placeholder="Search user">' +
                                            '</div>' : '') +
                                            '<ul class="dropdown dropdown-select">' +
                                                user_options +
                                            '</ul>' +
                                            (Cache.app.isAdmin() ?
                                            '<div>' +
                                                '<button type="button" class="user-invite text-primary-small small"><i class="fa-solid fa-envelope"></i>Invite team members via email</button>' +
                                            '</div>' : '') +
                                        '</div>' +
                                    '</div>': '') +
                                '</div>') +
                            '</div>' +

                            (is_merged_feedback || this.model.get('priority') === 'neutral' ? '' :
                            '<div class="priority tooltip priority-text-' + (this.model.escape('priority').toLowerCase()) + '" data-title="' + Util.cap(this.model.escape('priority')) + '"><i class="fas fa-flag"></i></div>') +
                        '</div>' +

                        (view_type === 'grid' ?
                        '<div class="cta-buttons">' +
                            '<button class="primary small view">' +
                            (is_design ? 'View Design' : 'View Feedback') +
                            '</button>' +
                            (Cache.app.isClient() ? '' :
                            '<button class="primary primary-invert small tooltip share" data-title="Share"><i class="far fa-share"></i></button>') +
                        '</div>' : '');

        content +=  '</div>';

        if (!Cache.app.isClient() && !this.is_locked && !this.example_mode && !this.model.isExpired()) {
            content += '<div class="button-dropdown button-dropdown-actions">' +
                            '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                            '<div>' +
                                Template_Action_Dropdown(this.model) +
                            '</div>' +
                        '</div>';
        }

        if (this.is_locked) {
            content += '<div class="locked-status tooltip" data-title="Locked"><i class="fad fa-lock-alt"></i></div>';
        }

        if (this.isDesignApproved()) {
            content += '<div class="approval-badge badge-small badge-success-invert tooltip" data-title="Approved by ' + Util.htmlEntities(this.getApprovedBy()) + '">Approved</div>';
        } else if (this.isPendingDesignApproval()) {
            content += '<div class="approval-badge badge-small badge-warning-invert tooltip" data-title="Pending approval from ' + Util.htmlEntities(this.getApprover()) + '">Pending</div>';
        }

        this.$el.html(content);

        this.$el.attr('priority', this.model.get('priority').toLowerCase());
        this.$el.attr('loadtype', this.model.get('load_type'));

        if (this.is_locked) {
            this.$el.attr('locked', 1);
        }

        if (this.model.isPdf() && !this.is_pdf_rendered) {
            var loading_task = PDFJS.getInstance().getDocument(this.model.get('screenshot'));
            loading_task.promise.then((pdf) => {
                pdf.getPage(1).then((page) => {
                    var viewport  = page.getViewport({scale: 1});
                    var canvas    = this.$el.find('.pdf-bg canvas').get(0);
                    var context   = canvas.getContext('2d');

                    canvas.width  = viewport.width;
                    canvas.height = viewport.height;

                    page.render({
                        canvasContext: context,
                        viewport: viewport
                    });
                });
            }, (reason) =>{
                UI.error(reason);
            });
        }

        this.$el.toggleClass('feedback-preview-expired', this.model.isExpired());

        return this;
    }
});
